module.exports = __webpack_public_path__ + "static/media/KateSpadeCard.bd82bd82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registryOnboard/KateSpadeCard.png
// module id = 2020
// module chunks = 51